var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"check-diff-link"}},[(_vm.linkData.diffCount===0)?_c('div',{staticClass:"no-diff"},[_vm._v("\n    "+_vm._s(_vm.linkData.text)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.linkData.diffCount>0)?_c('div',{staticClass:"diff-count",on:{"click":function($event){_vm.linkClicked()}}},[_vm._v("\n    "+_vm._s(_vm.linkData.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ffe9386","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/IntentEngine/_components/_tableColumn/SelectTableShowDiffLink.vue
// module id = null
// module chunks = 